<template>
  <v-list-item-content>
    <v-list-item-subtitle class="my-0 py-0" style="max-height: 26px" v-if="item.submittedOn">
      <div class="overline" style="line-height: inherit; position: relative">
        <span v-if="!item.reviewedOn" style="top: -1px; position: relative">
          <v-icon small color="orange darken-1"> mdi-eye-off </v-icon>
        </span>
        <span v-if="item.reviewedOn" style="top: -1px; position: relative">
          <v-icon small color="green darken-1"> mdi-eye </v-icon>
        </span>
        <span
          :class="item.reviewedOn ? 'green--text text-darken-1' : 'orange--text text--darken-2'"
          v-if="item.submittedOn"
        >
          {{ item.reviewedOn ? "" + formatDate(item.reviewedOn) : $t("c_formsubmissions.t_pending_review") }}
        </span>
      </div>
    </v-list-item-subtitle>
    <v-list-item-subtitle class="my-0 py-0" style="max-height: 26px" v-else>
      <div class="overline" style="line-height: inherit">
        <span v-if="item.urgent" class="red--text text--darken-2" :class="item.submissionId ? 'mr-3' : ''">{{
          $t("c_formassignments.t_urgent")
        }}</span>
        <span v-if="item.submissionId" class="blue--text mr-3">{{ $t("c_formassignments.t_started") }}</span>
      </div>
    </v-list-item-subtitle>
    <v-list-item-title class="text-subtitle-1 text-wrap pt-1">
      {{ item.revisionName ? item.revisionName : item.name }}
    </v-list-item-title>
    <v-list-item-subtitle class="py-1" v-if="item.formDescription && parent != 'timeclock'">
      {{ item.formDescription }}
    </v-list-item-subtitle>
    <v-list-item-subtitle class="py-1" v-else-if="item.description">
      {{ item.description }}
    </v-list-item-subtitle>
    <v-list-item-subtitle>
      <!-- Due Date - Always show if available -->
      <span
        class="orange--text d-inline-block"
        :class="isDateExpired(item.expiresOn) ? 'text--darken-3' : 'text--lighten-1'"
        v-if="item.expiresOn"
      >
        {{ isDateExpired(item.expiresOn) ? "! Due" : "Due" }}
        {{ formatShortDate(item.expiresOn) }}
      </span>

      <!-- Approval Info - Show when reviewed -->
      <span
        class="green--text text--lighten-1"
        v-if="(item.submission && item.submission.reviewedOn) || item.reviewedOn"
      >
        <span v-if="item.expiresOn" class="mx-1">•</span>
        {{ getApprovalInfo(item) }}
      </span>
    </v-list-item-subtitle>
  </v-list-item-content>
</template>

<script>
import Helpers from "@/mixins/helpers";
import { DateTime } from "luxon";

export default {
  name: "FormListItem",
  mixins: [Helpers],
  props: {
    item: {
      type: Object,
    },
    parent: {
      type: String,
    },
  },
  methods: {
    formatShortDate(dateString) {
      if (!dateString) return "";
      const date = DateTime.fromISO(dateString);
      if (!date.isValid) return "";

      const now = DateTime.now();
      const startOfToday = now.startOf("day");
      const dateStart = date.startOf("day");

      if (dateStart.equals(startOfToday)) {
        return this.$t("t_today");
      } else if (date.year === now.year) {
        return date.toFormat("MMM d"); // e.g., "Nov 12"
      } else {
        return date.toFormat("MMM d, yyyy"); // e.g., "Nov 12, 2024"
      }
    },
    getApprovalInfo(item) {
      const submission = item.submission || item;
      const reviewedOn = submission.reviewedOn || item.reviewedOn;
      const reviewPass = submission.reviewPass;
      const reviewedBy = submission.reviewedByFriendlyName || item.reviewedByFriendlyName || "Reviewer";

      if (!reviewedOn) return "";

      const status =
        reviewPass === true
          ? this.$t("t_approved")
          : reviewPass === false
          ? this.$t("t_rejected")
          : this.$t("t_reviewed");

      return `${status} by ${reviewedBy}`;
    },
  },
};
</script>
